module.exports = __webpack_public_path__ + "static/media/data-concept.df760b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/data-concept.png
// module id = 6
// module chunks = 0